<template>
  <div>
    <v-container fluid class="pa-0">
      <section class="search-cmp">
        <Search margin="0" />
      </section>
    </v-container>

    <v-container v-if="loading">
      <v-row class="mt-5">
        <v-col sm="12 text-center">
          <v-progress-circular
            indeterminate
            color="primary"
            class="mb-5"
          ></v-progress-circular>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="mt-5 pl-5 mb-5" v-else>
      <v-row v-if="vehicle">
        <v-col>
          <div class="vehicle">
            <div class="text-h4" v-text="vehicle.name"></div>
            <div class="text-subtitle1" v-text="vehicle.description"></div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="12" md="8" v-if="vehicle">
          <VanDetailCard :item="{ ...vehicle, price: getTotalPrice }" />
          <v-expansion-panels accordion class="mt-4" v-model="panel">
            <v-expansion-panel expand v-model="panel">
              <v-expansion-panel-header>
                <span class="headline"> Add-ons </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col sm="12">
                    <table style="width: 100%">
                      <tr class="tr">
                        <th class="text-left">Item</th>
                        <th class="text-left">Description</th>
                        <th class="text-left">Price</th>
                        <th class="text-left">Action</th>
                      </tr>
                      <tr
                        v-for="(addon, i) in getAddons"
                        :key="addon.id"
                        class="tr"
                      >
                        <td>
                          <span class="text-subtitle-2">
                            {{ addon.name }}
                          </span>
                        </td>
                        <td>
                          <span class="text-subtitle-2">
                            {{ addon.description }}
                          </span>
                        </td>
                        <td>
                          <span class="text-subtitle-2">
                            ${{ addon.price
                          }}{{ addon.paymentType === "daily" ? "/ day" : null }}
                          </span>
                        </td>
                        <td>
                          <div>
                            <!-- <v-btn dark small color="accent">
                              <v-icon dark> mdi-plus </v-icon> Add
                            </v-btn>

                            <span v-text="0" class="text-subtitle-1 ml-2 mr-2">
                            </span>

                            <v-btn fab dark x-small color="accent">
                              <v-icon dark> mdi-plus </v-icon>
                            </v-btn> -->
                            <span v-if="addon.totalBooked >= addon.quantity" id="unavailable-id">
                              Unavailable
                            </span>
                            <v-checkbox
                              v-else
                              v-model="getAddons[i].checked"
                              color="primary"
                              hide-details
                            id="submit-check"
                            >
                            </v-checkbox>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- driving liecence -->
          <v-card
            :loading="loadingDl"
            class="mt-4"
            ref="dl"
            v-if="!drivingLicence.length"
            id="DlInfo-card"
          >
            <v-card-title class="text-primary border-bottom">
              Driver’s License Info
            </v-card-title>
            <v-card-text class="mt-4" v-if="!loadingDl">
              <v-row v-if="drivingLicence.length">
                <v-radio-group v-model="dlSelected">
                  <v-col
                    sm="12"
                    class="d-flex"
                    v-for="dl in drivingLicence"
                    :key="dl.id"
                    cols="12"
                  >
                    <v-radio
                      v-if="dl"
                      :label="`${dl.name}, ${
                        dl.documentNumber
                      }, Expires: ${VueMoment(dl.expire)}`"
                      :value="dl.id"
                      class="mr-5"
                    >
                    </v-radio>
                    <v-btn
                      color="primary ml-5"
                      text
                      small
                      @click="editDrivingLicence(dl)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </v-col>
                </v-radio-group>
              </v-row>

              <v-row>
                <v-col sm="12" class="text-center" v-if="canAddAdditionalDL">
                  <v-btn color="primary" @click="drivingLicenceModel = true" id="add-DL">
                    <v-icon left>mdi-plus</v-icon>
                    Add Driver’s License
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- insurance card -->
          <v-card class="mt-4" ref="insurance" v-if="!insuranceData.length">
            <v-card-title class="border-bottom"> Insurance Info </v-card-title>
            <form @submit.prevent="saveInsurance">
              <v-card-text>
                <v-row>
                  <v-col sm="12" md="6" class="pb-0" cols="12">
                    <v-text-field
                      label="Insurance Company *"
                      outlined
                      v-model="insurance.insurance_company"
                      @blur="$v.insurance.insurance_company.$touch()"
                      :error="$v.insurance.insurance_company.$error"
                      id="insurance-text"
                    />
                  </v-col>
                  <v-col sm="12" md="6" class="pb-0" cols="12">
                    <v-text-field
                      label="Policy No. *"
                      outlined
                      v-model="insurance.policy_no"
                      @blur="$v.insurance.policy_no.$touch()"
                      :error="$v.insurance.policy_no.$error"
                      id="policy-id"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12" md="12" class="pb-0" cols="12">
                    <DatePicker
                      v-if="insurance.expiry_date"
                      v-model="$v.insurance.expiry_date.$model"
                      label="Expiry Date *"
                      :yearProps="insurance.expiry_date.split('-')[0]"
                      :monthProps="insurance.expiry_date.split('-')[1]"
                      :dayProps="insurance.expiry_date.split('-')[2]"
                      :from="new Date().getFullYear()"
                      id="start-date"
                    />
                    <DatePicker
                      v-else
                      v-model="$v.insurance.expiry_date.$model"
                      label="Expiry Date *"
                      :from="new Date().getFullYear()"
                      id="end-test"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12" md="12" class="pb-0" cols="12">
                    <v-text-field
                      label="State"
                      outlined
                      v-model="insurance.state"
                      @blur="$v.insurance.state.$touch()"
                      :error="$v.insurance.state.$error"
                      id="insurance-id"
                    />
                  </v-col>
                </v-row>
                <v-row class="mt-2">
                  <v-col sm="6" cols="12">
                    <v-file-input
                      label="Front Image"
                      outlined
                      v-model="$v.insurance.front.$model"
                      :error="$v.insurance.front.$error"
                      @blur="$v.insurance.front.$touch()"
                      :error-messages="
                        $v.insurance.front.$error
                          ? 'Please upload a valid image'
                          : null
                      "
                      :rules="[(value) => {
                        return testFile(value);
                      }]"
                      id="front-immage"
                    ></v-file-input>
                  </v-col>
                  <v-col sm="6" cols="12">
                    <v-file-input
                      label="Back Image"
                      outlined
                      v-model="$v.insurance.back.$model"
                      :error="$v.insurance.back.$error"
                      @blur="$v.insurance.back.$touch()"
                      :error-messages="
                        $v.insurance.back.$error
                          ? 'Please upload a valid image'
                          : null
                      "
                      :rules="[(value) => {
                        return testFile(value);
                      }]"
                      id="back-image"
                    ></v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12" class="d-flex justify-end">
                    <v-btn
                      color="primary"
                      :loading="insuranceCreating"
                      :disabled="insuranceCreating"
                      type="submit"
                      id="save-data"
                    >
                      <!-- <v-icon left>mdi-plus</v-icon> -->
                      Save insurance
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </form>
          </v-card>

          <!-- personal address -->
          <v-card
            class="mt-4"
            :loading="loadingAddress"
            ref="address"
            v-if="!address.length"
          >
            <v-card-title class="text-primary border-bottom">
              Personal Address
            </v-card-title>
            <v-card-text class="mt-4" v-if="!loadingAddress">
              <v-row v-if="address.length">
                <v-radio-group v-model="addressSelected">
                  <v-col
                    sm="12"
                    class="d-flex"
                    v-for="add in address"
                    :key="add.id"
                  >
                    <v-radio
                      :label="`${add.line1}, ${add.city}, ${add.state}, ${add.zip}`"
                      :value="add.id"
                      class="mr-5"
                    >
                    </v-radio>
                    <v-btn
                      color="primary ml-5"
                      text
                      small
                      @click="editAddress(add)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </v-col>
                </v-radio-group>
              </v-row>

              <v-row v-else>
                <v-col sm="12" class="text-center">
                  <v-btn color="primary" @click="addressDialog = true">
                    <v-icon left>mdi-plus</v-icon>
                    Add Address
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- credit card -->
          <template v-if="!selectedCard">
            <v-card class="mt-4" v-if="!isMember">
              <v-card-title class="text-primary border-bottom">
                Card Details
              </v-card-title>
              <v-card-text class="mt-4">
                <StripeElementCard
                  ref="elementRef"
                  :pk="getStripePK"
                  @token="tokenCreated"
                />
              </v-card-text>
            </v-card>
          </template>
        </v-col>
        <v-col sm="12" md="4">
          <!-- pickup and drop time -->
          <v-card ref="pickup-time">
            <v-card-title class="text-primary border-bottom">
              Pick up time and drop off time
            </v-card-title>
            <v-card-text>
              <v-row class="pt-4">
                <v-col sm="6">
                  <span class="text-subtitle1" id="btn-pick-time">Pick up time</span>
                  <v-menu offset-y min-width="auto">
                    <template #activator="{ on, attrs }">
                      <div
                      id="search-textbox"
                        class="search-textbox"
                        style="padding: 5px 10px"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-clock-outline</v-icon>
                        <span class="search-box-label" id="search-box-label">{{ pickupTime || 'Select pickup time' }}</span>
                      </div>
                    </template>
                    <v-list class="pa-0" id="v-list">
                      <v-list-item
                        v-for="time in getPickupTime"
                        :key="time.id"
                        class="pa-1 pt-0 pb-0"
                        @click="pickupTime = time.name"
                        id="time-pic"
                      >
                        <v-btn text color="primary" dark id="v-btn">
                          {{ time.name }}
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
                <v-col sm="6">
                  <span class="text-subtitle1">Drop off time</span>
                  <v-menu offset-y min-width="auto">
                    <template #activator="{ on, attrs }">
                      <div
                        class="search-textbox"
                        style="padding: 5px 10px"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-clock-time-four</v-icon>
                        <span class="search-box-label">{{ returnTime }}</span>
                      </div>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        v-for="time in getDropOff"
                        :key="time.id"
                        class="pa-1 pt-0 pb-0"
                        @click="returnTime = time.name"
                      >
                        <v-btn text color="primary" dark>
                          {{ time.name }}
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <div class="sticky-card mt-4">
            <v-card>
              <v-card-title>{{ vehicle ? vehicle.name : "" }}</v-card-title>

              <v-card-text>
                <v-row align="center" class="mx-0">
                  <!-- <v-rating
                    :value="4.5"
                    dense
                    half-increments
                    readonly
                    size="14"
                  >
                  </v-rating> -->
                </v-row>
                <v-row class="d-flex justify-space-between pl-4 pr-4 mt-4">
                  <div>
                    <span
                      class="text-substitle-1 text-primary"
                      v-text="'Pick up:- '"
                    >
                    </span>
                    <span
                      class="text-substitle-1 font-weight-bold"
                      v-text="
                        formattedDate($route.query.start) + ' ' + pickupTime
                      "
                    >
                    </span>
                  </div>
                  <div>
                    <span
                      class="text-substitle-1 text-primary"
                      v-text="'Drop off:- '"
                    >
                    </span>
                    <span
                      class="text-substitle-1 font-weight-bold"
                      v-text="
                        formattedDate($route.query.end) + ' ' + returnTime
                      "
                    >
                    </span>
                  </div>
                </v-row>

                <v-row class="d-flex justify-space-between pl-4 pr-4 mt-5">
                  <span
                    v-if="isMember"
                    class="text-h6 text-primary font-weight-regular"
                    v-text="'Extra days' + `(${applied ? 0 : getExtraDaysBooked}):`"
                  >
                  </span>
                  <span
                    v-else
                    class="text-h6 text-primary font-weight-regular"
                    v-text="'Booking charge:'"
                  >
                  </span>
                  <span
                    class="text-h6 text-primary font-weight-bold"
                    v-text="$t('dollor') + (user.free === 1 ? 0 : (applied ? 0 : getVehicleCharge))"
                  >
                  </span>
                </v-row>
                <v-row class="d-flex justify-space-between pl-4 pr-4">
                  <span
                    class="text-h6 text-primary font-weight-regular"
                    v-text="'Add-ons:'"
                  >
                  </span>
                  <span
                    class="text-h6 text-primary font-weight-bold"
                    v-text="$t('dollor') + getAddonTotal"
                  >
                  </span>
                </v-row>
                <v-row>
                  <ul style="width: 80%">
                    <li
                      class="d-flex justify-space-between"
                      v-for="addon in getSelectedAddOns"
                      :key="addon.id"
                    >
                      <span
                        class="text-subtitle2 text-primary font-weight-regular"
                        v-text="addon.name + ': '"
                      >
                      </span>
                      <span
                        class="text-subtitle2 text-primary font-weight-bold"
                        v-text="
                          $t('dollor') +
                          addon.price +
                          (addon.paymentType === 'daily' ? '/day' : '')
                        "
                      >
                      </span>
                    </li>
                  </ul>
                </v-row>
                <v-row
                  class="d-flex justify-space-between pl-4 pr-4"
                  v-if="!isMember"
                >
                  <span
                    class="text-h6 text-primary font-weight-regular"
                    v-text="'Usage fee:'"
                  >
                  </span>
                  <span
                    class="text-h6 text-primary font-weight-bold"
                    v-text="$t('dollor') + getUsageFee"
                  >
                  </span>
                </v-row>
                <v-row
                  class="d-flex justify-space-between pl-4 pr-4"
                >
                  <span
                    class="text-h6 text-primary font-weight-regular"
                    v-text="'Taxes and Fees:'"
                  >
                  </span>
                  <span
                    class="text-h6 text-primary font-weight-bold"
                    v-text="$t('dollor') + getTaxes"
                  >
                  </span>
                </v-row>
                <v-row>
                  <ul style="width: 80%">
                    <li
                      class="d-flex justify-space-between"
                    >
                      <span
                        class="text-subtitle2 text-primary font-weight-regular"
                        v-text="'King County Sales Tax:'"
                      >
                      </span>
                      <span
                        class="text-subtitle2 text-primary font-weight-bold"
                        v-text="
                          $t('dollor') + getKingCountyTax"
                      >
                      </span>
                    </li>
                    <li
                      class="d-flex justify-space-between"
                    >
                      <span
                        class="text-subtitle2 text-primary font-weight-regular"
                        v-text="'Washington State Sales Tax:'"
                      >
                      </span>
                      <span
                        class="text-subtitle2 text-primary font-weight-bold"
                        v-text="
                          $t('dollor') + getWashingtonCountyTax"
                      >
                      </span>
                    </li>
                  </ul>
                </v-row>
                <v-row
                  class="d-flex justify-space-between pl-4 pr-4"
                  v-if="!isMember"
                >
                  <span
                    class="text-h6 text-primary font-weight-regular"
                    v-text="'Security Deposit:'"
                  >
                  </span>
                  <span
                    class="text-h6 text-primary font-weight-bold"
                    v-text="$t('dollor') + getSecurityDeposit"
                  >
                  </span>
                </v-row>
                <v-row class="d-flex justify-space-between pl-4 pr-4">
                  <span
                    class="text-h6 text-primary font-weight-regular"
                    v-text="'Total:'"
                  >
                  </span>
                  <span
                    class="text-h6 text-primary font-weight-bold"
                    v-text="$t('dollor') + (user.free === 1 ? (getGrandTotal - getVehicleCharge).toFixed(2) : (applied ? (getGrandTotal - getVehicleCharge).toFixed(2) : getGrandTotal))"
                  >
                  </span>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="8" style="margin-bottom: 0; padding-bottom: 0;">
                    <v-text-field
                      outlined
                      label="Coupon code"
                      v-model="couponCode"
                      id="coupon-code"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" style="margin-bottom: 0; padding-bottom: 0;">
                    <v-btn
                      color="error"
                      x-large
                      block
                      @click="() => applied = false"
                      v-if="applied"
                    >
                      Remove
                    </v-btn>
                    <v-btn
                      color="primary"
                      x-large
                      block
                      :loading="applying"
                      @click="handleApplyCoupon"
                      v-else
                    >
                      Apply
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-textarea
                      outlined
                      rows="3"
                      placeholder="Notes if any"
                      v-model="note"
                    >

                    </v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <!-- <div>
                      <v-checkbox v-model="checkoutForm.agree">
                        <template v-slot:label>
                          <div>
                            I agree to the
                            <template>
                              <router-link to="/terms">
                                <span class="text-primary">
                                  Terms and Conditions
                                </span>
                              </router-link>
                            </template>
                          </div>
                        </template>
                      </v-checkbox>
                    </div> -->

                    <div class="" id="Trip_Book_btn">
                      <v-btn
                        color="secondary"
                        :loading="creating"
                        type="button"
                        x-large
                        block
                        @click="scrollToPosition"
                        v-if="disableBookNowButton"
                        id="Book-Button"
                      >
                        <span v-if="getVehicleStatus" id="unavialable-id"> Unavailable </span>
                        <span v-else-if="disableBookNowButton" id="book-btn-button">
                          BOOK NOW
                        </span>
                        <span v-else
                          >BOOK NOW <v-icon>mdi-check-bold</v-icon></span
                        >
                      </v-btn>
                      <v-btn
                        v-else
                        color="accent"
                        :loading="creating"
                        type="submit"
                        x-large
                        block
                        :disabled="
                          creating ||
                          getVehicleStatus ||
                          disableBookNowButton
                        "
                        @click="createBooking"
                      >
                        <span v-if="getVehicleStatus"> Unavailable </span>
                        <span v-else-if="disableBookNowButton">
                          BOOK NOW
                        </span>
                        <span v-else
                          >BOOK NOW <v-icon>mdi-check-bold</v-icon></span
                        >
                      </v-btn>
                      <span class="text-subtitle2 error--text" v-if="disableBookNowButton">
                          Please select
                          {{!this.insuranceData.length ? 'insurance, ' : ''}}
                          {{!this.addressSelected ? 'address, ' : ''}} 
                          {{ !this.dlSelected ? 'Driving Licence, ' : ''}}
                          {{!pickupTime ? 'pickup time' : ''}}
                      </span>
                      <!-- <div>
                        Note:- $35 + tax usage fee charged per booking
                      </div> -->
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <Getintouch />

    <!-- dl model -->
    <v-dialog
      v-model="drivingLicenceModel"
      transition="dialog-bottom-transition"
      max-width="500px"
    >
      <template v-slot:default="drivingLicenceModel">
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="saveDrivingLicence">
                <v-row>
                  <v-col sm="12" md="12" cols="12">
                    <v-text-field
                      label="Name *"
                      outlined
                      v-model="$v.dlForm.name.$model"
                      @blur="$v.dlForm.name.$touch()"
                      :error="$v.dlForm.name.$error"
                    />
                  </v-col>
                  <v-col sm="12" md="12" cols="12">
                    <DatePicker
                      v-model="$v.dlForm.dob.$model"
                      label="Date of Birth *"
                      :yearProps="dlForm.dob.split('-')[0]"
                      :monthProps="dlForm.dob.split('-')[1]"
                      :dayProps="dlForm.dob.split('-')[2]"
                    />
                    <span v-if="$v.dlForm.dob.$error" class="red--text">
                      This field is required.
                    </span>
                  </v-col>
                  <v-col sm="12" md="12" cols="12">
                    <v-text-field
                      label="Driver’s License Number *"
                      outlined
                      v-model="$v.dlForm.driving_license.$model"
                      @blur="$v.dlForm.driving_license.$touch()"
                      :error="$v.dlForm.driving_license.$error"
                    />
                  </v-col>
                  <v-col sm="12" md="12" cols="12">
                    <DatePicker
                      label="Driver’s License Expiry Date *"
                      :from="new Date().getFullYear()"
                      v-model="$v.dlForm.exp.$model"
                      :yearProps="dlForm.exp.split('-')[0]"
                      :monthProps="dlForm.exp.split('-')[1]"
                      :dayProps="dlForm.exp.split('-')[2]"
                    />
                    <span v-if="$v.dlForm.exp.$error" class="red--text">
                      This field is required.
                    </span>
                  </v-col>
                  <v-col sm="12" md="6" cols="12">
                    <v-file-input
                      label="Front driving license *"
                      outlined
                      v-model="dlForm.front"
                      :error-messages="
                        $v.dlForm.front.$error ? 'This field is required' : ''
                      "
                      :rules="[(value) => {
                        return testFile(value);
                      }]"
                    ></v-file-input>
                  </v-col>
                  <v-col sm="12" md="6" cols="12">
                    <v-file-input
                      label="Back driving license *"
                      outlined
                      v-model="dlForm.back"
                      :error-messages="
                        $v.dlForm.back.$error ? 'This field is required' : ''
                      "
                      :rules="[(value) => {
                        return testFile(value);
                      }]"
                    ></v-file-input>
                  </v-col>
                  <v-col sm="12" md="12">
                    <v-btn
                      color="primary"
                      block
                      type="submit"
                      :loading="savingDL"
                      :disabled="savingDL"
                    >
                      Save
                    </v-btn>
                  </v-col>
                </v-row>
              </form>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="drivingLicenceModel.value = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <!-- end model -->

    <!-- address model -->
    <v-dialog
      v-model="addressDialog"
      transition="dialog-bottom-transition"
      max-width="500px"
    >
      <template v-slot:default="addressDialog">
        <v-card class="pt-4">
          <v-card-text>
            <v-container>
              <form @submit.prevent="saveAddress">
                <v-row>
                  <v-col sm="12" md="12" cols="12">
                    <v-text-field
                      label="Address *"
                      outlined
                      v-model="$v.checkoutForm.address.$model"
                      @blur="$v.checkoutForm.address.$touch()"
                      :error="$v.checkoutForm.address.$error"
                    />
                  </v-col>
                  <v-col sm="12" md="4" cols="12">
                    <v-text-field
                      label="City *"
                      outlined
                      v-model="$v.checkoutForm.city.$model"
                      @blur="$v.checkoutForm.city.$touch()"
                      :error="$v.checkoutForm.city.$error"
                    />
                  </v-col>
                  <v-col sm="12" md="4" cols="12">
                    <v-text-field
                      label="Province/State *"
                      outlined
                      v-model="$v.checkoutForm.state.$model"
                      @blur="$v.checkoutForm.state.$touch()"
                      :error="$v.checkoutForm.state.$error"
                    />
                  </v-col>
                  <v-col sm="12" md="4" cols="12">
                    <v-text-field
                      label="ZIP / Postal Code *"
                      outlined
                      v-model="$v.checkoutForm.zip.$model"
                      @blur="$v.checkoutForm.zip.$touch()"
                      :error="$v.checkoutForm.zip.$error"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12">
                    <v-btn
                      type="submit"
                      :loading="creatingAddress"
                      color="primary"
                      block
                    >
                      Save
                    </v-btn>
                  </v-col>
                </v-row>
              </form>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="addressDialog.value = false"> Close </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <!-- end model -->

    <!-- booking success -->
    <v-dialog v-model="booked" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5"> Booking confirmed </v-card-title>
        <v-card-text>
          <p>Your booking has been confirmed.</p>
          <p>You will receive a confirmation email shortly.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" id="ViewTrip" @click="navigateBooking('/trips')">
            View trips
          </v-btn>
          <v-btn color="primary" @click="navigateBooking('/')" id="Go-Home"> Go Home </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- small screen booking button -->
    <!-- <div class="sticky-button">
      <div>
        <v-btn
          color="accent"
          :loading="creating"
          type="submit"
          x-large
          block
          :disabled="
            creating ||
            getVehicleStatus ||
            disableBookNowButton
          "
          @click="createBooking"
        >
          <span v-if="getVehicleStatus"> Unavailable </span>
          <span v-else-if="disableBookNowButton">
            BOOK NOW
          </span>
          <span v-else
            >BOOK NOW <v-icon>mdi-check-bold</v-icon></span
          >
        </v-btn>
        <span class="text-subtitle2 error--text" v-if="disableBookNowButton">
            Please select
            {{!this.insuranceData.length ? 'insurance, ' : ''}}
            {{!this.addressSelected ? 'address, ' : ''}} 
            {{ !this.dlSelected ? 'Driving Licence, ' : ''}}
            {{!pickupTime ? 'pickup time' : ''}}
        </span>
      </div>
    </div> -->
    <!-- end button -->

    <!-- dialog -->
    <v-dialog v-model="hasMemberDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Join Now </v-card-title>
        <v-card-text>Please join membership to book a trip.</v-card-text>
        <v-card-actions>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-btn color="error" block to="/"> Home </v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-btn color="primary" block to="/membership">
                Join now
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="acceptBooking" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5"> Accept and Book </v-card-title>
        <v-card-text>

          <v-row class="d-flex justify-space-between pl-4 pr-4 mt-5">
            <span
              v-if="isMember"
              class="text-h6 text-primary font-weight-regular"
              v-text="'Extra days' + `(${applied ? 0 : getExtraDaysBooked}):`"
            >
            </span>
            <span
              v-else
              class="text-h6 text-primary font-weight-regular"
              v-text="'Booking charge:'"
            >
            </span>
            <span
              class="text-h6 text-primary font-weight-bold"
              v-text="$t('dollor') + (user.free === 1 ? 0 : (applied ? 0 : getVehicleCharge))"
            >
            </span>
          </v-row>
          <v-row class="d-flex justify-space-between pl-4 pr-4">
            <span
              class="text-h6 text-primary font-weight-regular"
              v-text="'Add-ons:'"
            >
            </span>
            <span
              class="text-h6 text-primary font-weight-bold"
              v-text="$t('dollor') + getAddonTotal"
            >
            </span>
          </v-row>
          <v-row>
            <ul style="width: 80%">
              <li
                class="d-flex justify-space-between"
                v-for="addon in getSelectedAddOns"
                :key="addon.id"
              >
                <span
                  class="text-subtitle2 text-primary font-weight-regular"
                  v-text="addon.name + ': '"
                >
                </span>
                <span
                  class="text-subtitle2 text-primary font-weight-bold"
                  v-text="
                    $t('dollor') +
                    addon.price +
                    (addon.paymentType === 'daily' ? '/day' : '')
                  "
                >
                </span>
              </li>
            </ul>
          </v-row>
          <v-row
            class="d-flex justify-space-between pl-4 pr-4"
            v-if="!isMember"
          >
            <span
              class="text-h6 text-primary font-weight-regular"
              v-text="'Usage fee:'"
            >
            </span>
            <span
              class="text-h6 text-primary font-weight-bold"
              v-text="$t('dollor') + getUsageFee"
            >
            </span>
          </v-row>
          <v-row
            class="d-flex justify-space-between pl-4 pr-4"
          >
            <span
              class="text-h6 text-primary font-weight-regular"
              v-text="'Taxes and Fees:'"
            >
            </span>
            <span
              class="text-h6 text-primary font-weight-bold"
              v-text="$t('dollor') + getTaxes"
            >
            </span>
          </v-row>
          <v-row>
            <ul style="width: 80%">
              <li
                class="d-flex justify-space-between"
              >
                <span
                  class="text-subtitle2 text-primary font-weight-regular"
                  v-text="'King County Sales Tax:'"
                >
                </span>
                <span
                  class="text-subtitle2 text-primary font-weight-bold"
                  v-text="
                    $t('dollor') + getKingCountyTax"
                >
                </span>
              </li>
              <li
                class="d-flex justify-space-between"
              >
                <span
                  class="text-subtitle2 text-primary font-weight-regular"
                  v-text="'Washington State Sales Tax:'"
                >
                </span>
                <span
                  class="text-subtitle2 text-primary font-weight-bold"
                  v-text="
                    $t('dollor') + getWashingtonCountyTax"
                >
                </span>
              </li>
            </ul>
          </v-row>
          <v-row
            class="d-flex justify-space-between pl-4 pr-4"
            v-if="!isMember"
          >
            <span
              class="text-h6 text-primary font-weight-regular"
              v-text="'Security Deposit:'"
            >
            </span>
            <span
              class="text-h6 text-primary font-weight-bold"
              v-text="$t('dollor') + getSecurityDeposit"
            >
            </span>
          </v-row>
          <v-row class="d-flex justify-space-between pl-4 pr-4">
            <span
              class="text-h6 text-primary font-weight-regular"
              v-text="'Total:'"
            >
            </span>
            <span
              class="text-h6 text-primary font-weight-bold"
              v-text="$t('dollor') + (user.free === 1 ? (getGrandTotal - getVehicleCharge).toFixed(2) : (applied ? (getGrandTotal - getVehicleCharge).toFixed(2) : getGrandTotal))"
            >
            </span>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-btn color="error" block @click="acceptBooking = false">
                Cancel
              </v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-btn color="primary" block
                @click="acceptAndBookProceed"
                :loading="creating"
              >
                Accept and Book
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Getintouch from "@/components/cards/Getintouch.vue";
import VanDetailCard from "@/components/cards/VanDetailCard.vue";
import { mapGetters } from "vuex";
import axios from "../../../modules/axios";
import Search from "@/components/search/Search.vue";
import moment from "moment";
import { StripeElementCard } from "@vue-stripe/vue-stripe";
import constants from "../../../modules/constants";
const { api_keys } = constants;
import { required } from "vuelidate/lib/validators";
import { v4 as uuid } from "uuid";
// import firebase from "firebase/compat/app";
import DatePicker from "@/components/picker/DatePicker.vue";
import { storage } from "../../../modules/database";

// const DEFAULT_TAX = 10.25/100;
const KING_COUNTY = 3.75/100;
const WASHINGHTON_TAX = 6.5/100;

export default {
  data: () => ({
    acceptBooking: false,
    note: "",
    couponCode: "",
    applying: false,
    applied: false,
    hasMemberDialog: false,
    cards: [],
    selectedCard: null,
    loadingCards: false,
    insuranceCreating: false,
    insuranceData: [],
    addons: [],
    vehicle: null,
    loading: false,
    panel: 0,
    panel1: null,
    availCredit: 0,
    loadingDl: false,
    drivingLicence: [],
    loadingAddress: false,
    address: [],
    addressSelected: null,
    dlSelected: null,
    pickupTime: "",
    returnTime: "09:00 AM",
    insurance: {
      front: null,
      back: null,
      insurance_company: "",
      policy_no: "",
      expiry_date: "",
      state: "Washington",
    },
    dlForm: {
      dob: "",
      driving_license: "",
      exp: "",
      name: "",
      id: null,
      front: "",
      back: "",
    },
    savingDL: false,
    drivingLicenceModel: false,
    addressDialog: false,
    checkoutForm: {
      address: "",
      city: "",
      state: "",
      zip: "",
      agree: true,
      id: null,
    },
    creatingAddress: false,
    creating: false,

    booked: false,
  }),
  computed: {
    ...mapGetters({
      user: "getUser",
      order: "getOrder",
    }),
    disableBookNowButton() {
      return (
        !this.insuranceData?.length || !this.dlSelected || !this.addressSelected || !this.pickupTime
      );
    },
    getVehicleStatus() {
      const available = this.vehicle?.available;
      return available > 0 ? false : true;
    },
    getTotalPrice() {
      if (this.user?.member) {
        let price = 0;
        const numOfDays = this.getBookingDays;

        if (numOfDays <= this.availCredit) {
          price = 0;
        } else {
          const extraDays = numOfDays - this.availCredit;

          // member extra price will be half price of vehicle
          price = extraDays * (this.vehicle.price / 2);
        }

        // addons
        price += this.getAddonTotal;

        return price;
      }
      let total = this.vehicle?.price ?? 0;
      total = total * this.getBookingDays;
      total += this.getAddonTotal;

      return total;
    },
    getAddons() {
      if (this.user?.member) {
        return this.addons.filter((addon) => {
          return addon.onlyMember === 1 || addon.onlyMember === 0;
        });
      }

      return this.addons.filter((addon) => {
        return addon.onlyMember === 2 || addon.onlyMember === 0;
      });
    },
    canAddAdditionalDL() {
      if (this.user?.member) {
        return this.drivingLicence.length < 1;
      }

      // disable when dl length is 2
      return this.drivingLicence.length < 2;
    },
    getDropOff() {
      return [
        {
          name: "09:00 AM",
          id: "p1",
        },
        {
          name: "09:30 AM",
          id: "p2",
        },
        {
          name: "10:00 AM",
          id: "p3",
        },
        {
          name: "10:30 AM",
          id: "p4",
        },
        {
          name: "11:00 AM",
          id: "p5",
        },
        {
          name: "11:30 AM",
          id: "p6",
        },
        {
          name: "12:00 PM",
          id: "p7",
        },
        // {
        //   name: "12:30 PM",
        //   id: "p8",
        // },
        // {
        //   name: "01:00 PM",
        //   id: "p9",
        // },
        // {
        //   name: "01:30 PM",
        //   id: "p10",
        // },
        // {
        //   name: "02:00 PM",
        //   id: "p11",
        // },
        // {
        //   name: "02:30 PM",
        //   id: "p12",
        // },
        // {
        //   name: "03:00 PM",
        //   id: "p13",
        // },
        // {
        //   name: "03:30 PM",
        //   id: "p14",
        // },
        // {
        //   name: "04:00 PM",
        //   id: "p15",
        // },
      ];
    },
    getPickupTime() {
      const times = [
        // {
        //   name: "09:00 AM",
        //   id: "p1",
        // },
        // {
        //   name: "09:30 AM",
        //   id: "p2",
        // },
        // {
        //   name: "10:00 AM",
        //   id: "p3",
        // },
        // {
        //   name: "10:30 AM",
        //   id: "p4",
        // },
        // {
        //   name: "11:00 AM",
        //   id: "p5",
        // },
        // {
        //   name: "11:30 AM",
        //   id: "p6",
        // },
        // {
        //   name: "12:00 PM",
        //   id: "p7",
        // },
        // {
        //   name: "12:30 PM",
        //   id: "p8",
        // },
        {
          name: "01:00 PM",
          id: "p9",
        },
        {
          name: "01:30 PM",
          id: "p10",
        },
        {
          name: "02:00 PM",
          id: "p11",
        },
        {
          name: "02:30 PM",
          id: "p12",
        },
        {
          name: "03:00 PM",
          id: "p13",
        },
        {
          name: "03:30 PM",
          id: "p14",
        },
        {
          name: "04:00 PM",
          id: "p15",
        },
      ];

      const current = moment(this.$route.query.start).utc().valueOf();
      const currentTime = moment().utc().valueOf();

      const filter = times.filter(( time ) => {
        const date = moment().utc().format("YYYY-MM-DD");
        const currentTimeStamp = moment(date).utc().valueOf();

        const timeStamp = moment(date + " " + time.name).utc().valueOf();

        if ( currentTimeStamp === current ) {
          return timeStamp > currentTime;
        }

        return true;
      });

      return filter;
    },
    getStripePK() {
      return api_keys.STRIPE_KEY;
    },
    isMember() {
      return this.user?.member;
    },
    getSelectedAddOns() {
      return this.addons.filter((addon) => {
        return addon.checked;
      });
    },

    // bookings details
    getExtraDaysBooked() {
      let numOfDays = this.getBookingDays;
      let credit = this.availCredit ?? 0;
      const allowed_days = this.user?.plan?.allowed_days ?? [];

      const bookingStart = moment(this.$route.query.start).utc().format("YYYY-MM-DD");
      const bookingEnd = moment(this.$route.query.end).utc().format("YYYY-MM-DD");
      const bookedDates = datesBetweenTwoDays(bookingStart, bookingEnd);

      let otherDayBooking = 0;
      let bookingDays = 0;
      const allowed_days_array = allowed_days.split(",");
      if ( allowed_days_array?.length < 7 ) {
        bookedDates.forEach((date) => {
          const weekDay = moment(date).format("ddd").toUpperCase();
  
          // check if day is allowed in plan
          const isAllowed = allowed_days_array.includes(weekDay.toString());
          if (!isAllowed) {
            otherDayBooking++;
          } else {
            bookingDays++;
          }
        });

        if ( credit <= 0 ) {
          numOfDays = bookingDays + otherDayBooking;
        } else {
          const allDayBooking = credit > bookingDays ? 0 : bookingDays - credit;
          numOfDays = otherDayBooking + allDayBooking;
        }
      } else {

        if (numOfDays <= credit) {
          numOfDays = 0;
        } else {
          numOfDays = numOfDays - credit;
        }
      }

      return numOfDays;
    },
    getBookingDays() {
      const { start, end } = this.$route.query;
      if (start && end) {
        const startDay = moment(start);
        const endDay = moment(end);
        const diff = endDay.diff(startDay, "days");
        return diff + 1;
      }
      return "";
    },
    getVehicleCharge() {
      if (this.isMember) {
        const discount = this.isBookingIncludedInMembership();
        const estimatedDiscount = this.vehicle?.price * Number(discount.discount)/100;
        return discount && discount.discount < 100 ? (this.vehicle?.price - estimatedDiscount) * this.getBookingDays : (this.vehicle?.price / 2) * this.getExtraDaysBooked;
      }
      return this.vehicle?.price * this.getBookingDays;
    },
    getAddonTotal() {
      let total = 0;
      this.addons.forEach((addon) => {
        const price =
          addon.paymentType === "daily"
            ? addon.price * this.getBookingDays
            : addon.price;
        if (addon.checked) {
          total += price;
        }
      });
      return total;
    },
    getUsageFee() {
      return 35;
    },
    getSecurityDeposit() {
      return 500;
    },
    getTaxes() {
      if ( this.user.free === 1 ) {
        return 0;
      }
      // if (this.isMember) {
      //   const total = this.applied ? this.getAddonTotal : this.getVehicleCharge + this.getAddonTotal;
      //   console.log(total);
      //   const taxes = total * DEFAULT_TAX;
      //   return Number(taxes.toFixed(2));
      // }
      // const totalAmount =
      //   this.getAddonTotal +
      //   this.vehicle?.price * this.getBookingDays +
      //   this.getUsageFee;
      // const tax = totalAmount * DEFAULT_TAX;
      // return Number(tax.toFixed(2));

      return this.getKingCountyTax + this.getWashingtonCountyTax;
    },
    getKingCountyTax() {
      if ( this.user.free === 1 ) {
        return 0;
      }
      if (this.isMember) {
        const total = this.applied ? this.getAddonTotal : this.getVehicleCharge + this.getAddonTotal;
        const taxes = total * KING_COUNTY;
        return Number(taxes.toFixed(2));
      }
      const totalAmount =
        this.getAddonTotal +
        this.vehicle?.price * this.getBookingDays +
        this.getUsageFee;
      const tax = totalAmount * KING_COUNTY;
      return Number(tax.toFixed(2));
    },
    getWashingtonCountyTax() {
      if ( this.user.free === 1 ) {
        return 0;
      }
      if (this.isMember) {
        const total = this.applied ? this.getAddonTotal : this.getVehicleCharge + this.getAddonTotal;
        const taxes = total * WASHINGHTON_TAX;
        return Number(taxes.toFixed(2));
      }
      const totalAmount =
        this.getAddonTotal +
        this.vehicle?.price * this.getBookingDays +
        this.getUsageFee;
      const tax = totalAmount * WASHINGHTON_TAX;
      return Number(tax.toFixed(2));
    },
    getGrandTotal() {
      if (this.isMember) {
        const total = this.getVehicleCharge + this.getAddonTotal;
        return (total + this.getTaxes).toFixed(2);
      }
      const orderTotal = this.vehicle?.price * this.getBookingDays;
      return (
        this.getAddonTotal +
        orderTotal +
        this.getTaxes +
        this.getSecurityDeposit +
        this.getUsageFee
      ).toFixed(2);
    },
    isBookedInNonAllowedDays() {
      const allowed_days = this.user?.plan?.allowed_days ?? "";
      const bookingStart = moment(this.$route.query.start).utc().format("YYYY-MM-DD");
      const bookingEnd = moment(this.$route.query.end).utc().format("YYYY-MM-DD");
      const bookedDates = datesBetweenTwoDays(bookingStart, bookingEnd);
      const allowed_days_array = allowed_days.split(",");

      let isAllowed = true;
      if ( allowed_days_array?.length < 7 ) {
        bookedDates.forEach((date) => {
          const weekDay = moment(date).format("ddd").toUpperCase();

          // check if day is allowed in plan
          const allowed = allowed_days_array.includes(weekDay.toString());
          if ( !allowed ) {
            isAllowed = false;
          }
        });
      }

      return isAllowed;
    }
  },
  components: {
    VanDetailCard,
    Getintouch,
    Search,
    StripeElementCard,
    DatePicker,
  },
  mounted() {
    this.connectToServer();
    this.fetchAddress();
    this.fetchDocuments();
    this.fetchInsurance();
    this.fetchCards();
    this.checkMember();
  },
  methods: {
    async handleApplyCoupon() {
      if ( !this.couponCode ) {
        this.$root.toast("Please enter coupon code", "error");
        return
      }

      const rules = this.user?.plan_rules;
      if ( rules?.length ) {
        const rule = rules.find((rule) => rule.vehicleID === this.vehicle?.id);
        if ( rule ) {
          const isNotIncluded = rule.discount < 100;
          if ( isNotIncluded ) {
            this.applied = false;
            this.$root.toast("Coupon not applicable on this vehicle", "error");
            return;
          }
        }
      }

      // is booked dates are allowed in plan
      if ( !this.isBookedInNonAllowedDays ) {
        this.applied = false;
        this.$root.toast("Coupon not applicable", "error");
        return;
      }

      try {
        this.applying = true
        const res = await axios.post(`/apply/coupon/${this.couponCode}/${moment(this.$route.query.end).format("YYYY-MM-DD")}`);
        this.applied = res.data?.id;
        this.$root.toast("Coupon applied", "success")

      } catch (error) {
        this.$root.toast(error.response.data.message || "Something went wrong", "error");
      } finally {
        this.applying = false
      }
    },
    checkMember() {
      if (!this.isMember) {
        this.hasMemberDialog = true;
      }
    },
    testFile(file) {
      if ( !file ) {
        return "Please select a file"
      }

      const extensions = ["png", "jpg", "jpeg", "pdf"];
      const type = file.name.split(".")[1];
      if ( !extensions.includes(type) ) {
        return "Please select image or PDF file only"
      }

      return true;
    },
    getAddonsTotalSingle(addon) {
      let total = 0;
      total = addon.price;
      if (addon.paymentType == "daily") {
        total = total * this.getBookingDays;
      }
      return total;
    },
    async connectToServer() {
      this.loading = true;
      const { start, end } = this.$route.query;

      axios
        .get("/credit")
        .then((res) => {
          this.availCredit = res.data.credit;
        })
        .catch((err) => {
          console.log(err);
        });

      axios
        .get(
          "/vehicles/" + this.$route.params.id + `?start=${start}&end=${end}`
        )
        .then((response) => {
          this.vehicle = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });

      axios
        .get(`/add-ons?start=${start}&end=${end}`)
        .then((response) => {
          const data = response.data;

          if (data) {
            const filtered = data.filter((addon) => {
              if ( !addon.vehiclesIncluded ) {
                return true;
              }
              return addon.vehiclesIncluded?.split(",").includes(this.$route.params.id.toString());
            });
            this.addons = filtered.map((addon) => {
              return {
                ...addon,
                id: addon.id,
                name: addon.name,
                price: addon.regularPrice,
                checked: false,
                paymentType: addon.paymentType,
                description: addon.description,
                onlyMember: addon.onlyMember,
              };
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async fetchAddress() {
      try {
        this.loadingAddress = true;
        const response1 = await axios.get("/address");
        this.address = response1.data;
        this.addressSelected = this.address[0]?.id;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingAddress = false;
      }
    },
    async fetchDocuments() {
      // get all driving license
      try {
        this.loadingDl = true;
        const response = await axios.get("/documents");
        this.drivingLicence = response.data;
        this.dlSelected = this.drivingLicence[0]?.id;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingDl = false;
      }
    },
    fetchInsurance() {
      axios
        .get("/insurance?limit=1")
        .then((response) => {
          this.insuranceData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async fetchCards() {
      try {
        this.loadingCards = true;
        const response = await axios.get("/credit-card");
        this.cards = response.data;
        if ( this.cards?.length > 0 ) {
          this.selectedCard = response.data[0]?.id;
        }
      } catch (error) {
        if ( error.response.status === 404 ) {
          this.selectedCard = null;
        }
      } finally {
        this.loadingCards = false;
      }
    },
    tokenCreated(token) {
      this.creating = true;
      this.createOrder(token?.card.id, token?.id);
    },
    VueMoment(date) {
      return moment(date).utc().format("MM-DD-YYYY");
    },
    editDrivingLicence(dl) {
      this.dlForm = {};
      this.dlForm = {
        dob: dl.dob,
        driving_license: dl.documentNumber,
        exp: dl.expire,
        id: dl.id,
        name: dl.name,
        front: dl.front || null,
        back: dl.back || null,
      };
      this.drivingLicenceModel = true;
    },
    async saveDrivingLicence() {
      this.$v.dlForm.$touch();
      if (this.$v.dlForm.$error) {
        return;
      }

      this.savingDL = true;

      try {
        const { dob, driving_license, exp, id, name, front, back } =
          this.dlForm;
        const url = id ? `/documents/${id}` : "/documents";

        let frontPath = front;
        let backPath = back;
        if (front && "File" in window && front instanceof File) {
          frontPath = `documents/${this.user?.uid}/driving_licence/${uuid()}`;
          this.uploadFile(front, frontPath);
        }
        if (back && "File" in window && back instanceof File) {
          backPath = `documents/${this.user?.uid}/driving_licence/${uuid()}`;
          this.uploadFile(back, backPath);
        }

        if (id) {
          await axios.patch(url, {
            documentNumber: driving_license,
            dob,
            expire: exp,
            name,
            dlfront: frontPath,
            dlback: backPath,
          });
        } else {
          await axios.post(url, {
            documentNumber: driving_license,
            dob,
            expire: exp,
            name,
            dlfront: frontPath,
            dlback: backPath,
          });
        }

        this.$root.toast("Driving licence saved successfully", "success");
        this.drivingLicenceModel = false;
        this.fetchDocuments();

        //reset form here
        this.$nextTick(() => {
          this.dlForm = Object.keys(this.dlForm).forEach((key) => {
            this.dlForm[key] = "";
          });
        });
      } catch (error) {
        this.$root.toast("Something went wrong", "error");
      } finally {
        this.savingDL = false;
      }
    },
    uploadFile(file, path) {
      // upload to firebase storage
      const storageRef = storage.ref(path);
      const task = storageRef.put(file);
      task.on(
        "state_changed",
        (snapshot) => {
          // progress function
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log(progress);
        },
        (error) => {
          // error function
          console.log(error);
        },
        () => {
          // complete function
          return true;
        }
      );
    },
    editAddress(data) {
      this.checkoutForm = {
        address: data.line1,
        city: data.city,
        state: data.state,
        zip: data.zip,
        id: data.id,
      };
      this.addressDialog = true;
    },
    async saveAddress() {
      this.$v.checkoutForm.$touch();
      if (this.$v.checkoutForm.$error) {
        return;
      }

      this.creatingAddress = true;
      try {
        const { id } = this.checkoutForm;
        const url = id ? `/address/${id}` : "/address";

        if (id) {
          await axios.patch(url, {
            line1: this.checkoutForm.address,
            city: this.checkoutForm.city,
            state: this.checkoutForm.state,
            zip: this.checkoutForm.zip.toString(),
          });
        } else {
          await axios.post(url, {
            line1: this.checkoutForm.address,
            city: this.checkoutForm.city,
            state: this.checkoutForm.state,
            zip: this.checkoutForm.zip.toString(),
          });
        }

        this.fetchAddress();

        this.$root.toast("Address saved successfully", "success");
        this.addressDialog = false;
      } catch (error) {
        this.$root.toast("Something went wrong", "error");
      } finally {
        this.creatingAddress = false;
      }
    },
    formattedDate(date) {
      return moment(date).format("MMM Do YYYY");
    },
    async saveInsurance() {
      this.$v.insurance.$touch();
      console.log(this.$v.insurance);
      if (this.$v.insurance.$error) {
        return;
      }

      this.insuranceCreating = true;

      try {
        let front = "documents/" + this.user?.uid + "/insurance/front" + uuid();
        let back = "documents/" + this.user?.uid + "/insurance/back" + uuid();

        /// let it keep uploading
        this.uploadFile(this.insurance.front, front);
        this.uploadFile(this.insurance.back, back);
        const { insurance_company, policy_no, state, expiry_date } = this.insurance;

        await axios.post("/insurance", {
          front,
          back,
          insurance_company,
          policy_no,
          state,
          expiry_date,
        });

        this.fetchInsurance();
        this.$root.toast("Insurance saved successfully", "success");
        this.insuranceDialog = false;

        this.$nextTick(() => {
          this.insurance = {
            front: null,
            back: null,
          };
          this.$v.insurance.$reset();
        });
      } catch (error) {
        this.$root.toast("Something went wrong", "error");
      } finally {
        this.insuranceCreating = false;
      }
    },

    // bookings
    scrollToPosition() {
      if (!this.insuranceData?.length) {
        this.$root.toast("Please upload insurance", "error");
        this.$refs["insurance"].$el.scrollIntoView({
          block: "end",
          scrollBehavior: "smooth",
        });
        this.$refs["insurance"].$el.style.border = "1.5px solid #07c4e6";
        setTimeout(() => {
          this.$refs["insurance"].$el.style.border = "none";
        }, 1000);
        return;
      }
      if (!this.dlSelected) {
        this.$root.toast("Please add a driving licence", "error");
        this.$refs["dl"].$el.scrollIntoView({
          block: "end",
          scrollBehavior: "smooth",
        });
        this.$refs["dl"].$el.style.border = "1.5px solid #07c4e6";
        setTimeout(() => {
          this.$refs["dl"].$el.style.border = "none";
        }, 1000);
        return;
      }
      if (!this.addressSelected) {
        this.$root.toast("Please add an address", "error");
        this.$refs["address"].$el.scrollIntoView({
          block: "end",
          scrollBehavior: "smooth",
        });
        this.$refs["address"].$el.style.border = "1.5px solid #07c4e6";
        setTimeout(() => {
          this.$refs["address"].$el.style.border = "none";
        }, 1000);
        return;
      }
      if (!this.pickupTime) {
        this.$root.toast("Please select pickup time", "error");
        this.$refs["pickup-time"].$el.scrollIntoView({
          block: "end",
          scrollBehavior: "smooth",
        });
        this.$refs["pickup-time"].$el.style.border = "1.5px solid #07c4e6";
        setTimeout(() => {
          this.$refs["pickup-time"].$el.style.border = "none";
        }, 1000);
        return;
      }
    },
    createBooking() {
      // need to show message if user has no address or redirect to prrofille page

      if (!this.insuranceData?.length) {
        this.$root.toast("Please upload insurance", "error");
        this.$refs["insurance"].$el.scrollIntoView({
          block: "end",
          scrollBehavior: "smooth",
        });
        return;
      }
      if (!this.dlSelected) {
        this.$root.toast("Please add a driving licence", "error");
        this.$refs["dl"].$el.scrollIntoView({
          block: "end",
          scrollBehavior: "smooth",
        });
        return;
      }
      if (!this.addressSelected) {
        this.$root.toast("Please add an address", "error");
        this.$refs["address"].$el.scrollIntoView({
          block: "end",
          scrollBehavior: "smooth",
        });
        return;
      }
      // if (!this.checkoutForm.agree) {
      //   this.$root.toast("Please agree to the terms and conditions", "error");
      //   return;
      // }

      // open the dialog
      this.acceptBooking = true;
    },
    acceptAndBookProceed() {
      this.acceptBooking = false;

      if (this.isMember) {
        this.creating = true;
        this.createOrder("", "");
        return;
      }

      if ( this.selectedCard ) {
        this.creating = true;
        this.createOrder("", "");
      } else {
          this.$refs.elementRef?.submit?.();
      }
    },
    async createOrder(cardID, token) {
      const bookingDate = this.$route.query;

      try {
        let frontPath = "documents/" + this.user?.uid + "/insurance/" + uuid();
        let backPath = "documents/" + this.user?.uid + "/insurance/" + uuid();

        // this.uploadFile(this.insurance.front, frontPath);
        // this.uploadFile(this.insurance.back, backPath);

        const orderData = {
          order: {
            startDate: moment(bookingDate.start).format("YYYY-MM-DD"),
            endDate: moment(bookingDate.end).format("YYYY-MM-DD"),
            price: this.vehicle?.price,
            vehicleID: this.vehicle?.id,
            addressID: this.addressSelected ?? 0,
            drivingLicenceID: this.dlSelected ?? 0,
            pickupTime: this.pickupTime,
            dropTime: this.returnTime,
          },
          addOns: this.getSelectedAddOns?.map((addOn) => addOn.id),
          cardToken: token,
          cardID: cardID,
          uid: this.user?.sqlUID,
          member: this.isMember,
          insurance: {
            front: frontPath,
            back: backPath,
          },
          coupon: this.applied ? this.applied.toString() : "",
          note: this.note
        };

        await axios.post("/checkout", orderData);
        this.booked = true;
      } catch (error) {
        console.log(error);
        if ( error.response?.data ) {
          this.$root.toast(error.response.data.error, "error");
        } else {
          this.$root.toast("Something went wrong", "error");
        }
      } finally {
        this.creating = false;
      }
    },
    navigateBooking(route) {
      this.booked = false;
      this.$router.push(route);
    },
    isBookingIncludedInMembership() {
      const rule = this.user.plan_rules?.find((rule) => rule.vehicleID == this.$route.params.id);
      if ( rule ) {
        return rule
      }

      return false
    }
  },
  validations: {
    insurance: {
      front: {
        required,
      },
      back: {
        required,
      },
      insurance_company: {
        required,
      },
      policy_no: {
        required,
      },
      expiry_date: {
        required,
      },
      state: {},
    },
    dlForm: {
      dob: {
        required,
      },
      driving_license: {
        required,
      },
      exp: {
        required,
      },
      name: {
        required,
      },
      front: {
        required,
      },
      back: {
        required,
      },
    },
    checkoutForm: {
      address: {
        required,
      },
      city: {
        required,
      },
      state: {
        required,
      },
      zip: {
        required,
      },
    },
  },
  watch: {
    couponCode() {
      this.couponCode = this.couponCode.toUpperCase();
    }
  }
};

const datesBetweenTwoDays = function (startDate, endDate) {
    const dates = [];
  
    const currDate = moment(startDate).startOf("day");
    const lastDate = moment(endDate).startOf("day");
  
    while (currDate.add(1, "days").diff(lastDate) <= 0) {
      const formatted = moment(currDate.clone().toDate()).format("YYYY-MM-DD");
      dates.push(formatted)
    }
  
    return dates;
};
</script>

<style scoped lang="scss">
.sticky-card {
  position: sticky;
  top: 100px;
}
.vehicle {
  position: relative;
}
.vehicle::after {
  position: absolute;
  content: "";
  width: 80px;
  height: 3px;
  background: var(--red-color);
}
.tr td {
  padding: 10px 0;
}
.sticky-button {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--light);
  padding: 10px;
  z-index: 9999;
}
.hide-button {
  display: block;
}
@media screen and (max-width: 960px) {
  .sticky-button {
    display: block;
  }
  .hide-button {
    display: none;
  }
  .sticky-card {
    margin-bottom: 100px;
  }
}
</style>
